const API_BASE = import.meta.env.VITE_API_BASE || "";
const CONTACT_FORM_ENDPOINT = `${API_BASE}/api/contact/`;

export type ContactSubmission = {
  firstName: string;
  lastName: string;
  email: string;
  jobTitle: string;
  company?: string;
  message: string;
  utmId?: string;
  utmSource?: string;
};

export const submitContactForm = async (submission: ContactSubmission): Promise<void> => {
  const response = await fetch(CONTACT_FORM_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      firstName: submission.firstName,
      lastName: submission.lastName,
      email: submission.email,
      jobTitle: submission.jobTitle,
      company: submission.company || "",
      message: submission.message,
      utmId: submission.utmId || "",
      utmSource: submission.utmSource || "",
    }),
  });

  if (!response.ok) {
    let errorMessage = `Contact submission failed with status ${response.status}`;

    try {
      const errorBody = await response.json();
      if (errorBody?.error && typeof errorBody.error === "string") {
        errorMessage = errorBody.error;
      }
    } catch {
      // Keep fallback message when response body isn't JSON.
    }

    throw new Error(errorMessage);
  }
};
